/**
 * Returns a debounced async function from the specified function. All calls
 * are throttled with the specified timeout
 *
 * @param {T} fn The specified function to debounce.
 * @param {number} timeout Call the function if no calls are made within this
 * period.
 * @returns A new asynchronous function that can be used in place of the
 * original function.
 */
export function debouncePromise<T extends (...args: any[]) => any>(fn: T, timeout = 200) {
    let last: any;

    return function (...args: Parameters<T>) {
        if (last) {
            clearTimeout(last);
        }

        return new Promise<any>(resolve => {
            last = setTimeout(() => {
                fn(...args).then(resolve);
            }, timeout);
        });
    };
}
